module.exports = __webpack_public_path__ + "58a44520df39d6af6b5f9f97398caa89.svg";